module.exports = __webpack_public_path__ + "packs/media/images/apple-touch-icon-d66ce839cb980cce24e559d848343b36.png";